// Reste à vivre = 65 % des revenus mensuels avant abattements
const weight = 0.9;
const computeRemainingIncomes = (_, summary) => ({ remainingIncomes: (((summary.rawProfessionalIncomes + (weight * summary.rawRentalIncomes)) / 12) - summary.charges) });

export default computeRemainingIncomes;
